import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-body pt-6 pb-4 personal-form umt-form"
}
const _hoisted_2 = {
  key: 0,
  class: "fw-bolder text-primary text-uppercase fs-5 ps-3 border-start border-4 border-primary mb-5",
  style: {"font-weight":"700 !important"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu:", -1)
const _hoisted_5 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "1"),
  /*#__PURE__*/_createTextVNode(" Thông tin cơ bản")
], -1)
const _hoisted_7 = { class: "row g-5" }
const _hoisted_8 = { class: "col-xl-4 col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Họ tên", -1)
const _hoisted_10 = { class: "col-xl-4 col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-semibold mb-2 required",
  id: "tick-scroll"
}, "CMND/CCCD", -1)
const _hoisted_12 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "col-xl-4 col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Ngày cấp", -1)
const _hoisted_16 = { class: "col-xl-4 col-md-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Nơi cấp", -1)
const _hoisted_18 = { class: "col-xl-4 col-md-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Giới tính", -1)
const _hoisted_20 = { class: "col-xl-4 col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Nơi sinh (Tỉnh/TP)", -1)
const _hoisted_22 = { class: "col-xl-4 col-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Ngày, tháng, năm sinh", -1)
const _hoisted_24 = { class: "col-xl-4 col-md-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Điện thoại", -1)
const _hoisted_26 = { class: "col-xl-4 col-md-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Email", -1)
const _hoisted_28 = { class: "col-xl-4 col-md-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Dân tộc", -1)
const _hoisted_30 = { class: "col-xl-4 col-md-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Tôn giáo", -1)
const _hoisted_32 = { class: "col-xl-4 col-md-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Quốc tịch", -1)
const _hoisted_34 = { class: "col-xl-4 col-md-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Mã số thuế cá nhân", -1)
const _hoisted_36 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "2"),
  /*#__PURE__*/_createTextVNode(" Hộ khẩu thường trú")
], -1)
const _hoisted_38 = { class: "row g-5" }
const _hoisted_39 = { class: "col-xl-3 col-md-6" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Tỉnh / Thành phố", -1)
const _hoisted_41 = { class: "col-xl-3 col-md-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Phường / Xã", -1)
const _hoisted_43 = { class: "col-xl-6 col-12" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)", -1)
const _hoisted_45 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_46 = { class: "d-flex flex-wrap align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "3", -1)
const _hoisted_48 = {
  class: "wrap-check-aotufill ms-4 d-flex align-items-center",
  style: {"text-transform":"none","font-weight":"400"}
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkAddress",
  class: "ms-2 text-muted fs-7 cursor-pointer"
}, [
  /*#__PURE__*/_createElementVNode("i", null, "Giống địa chỉ thường trú")
], -1)
const _hoisted_51 = { class: "row g-5" }
const _hoisted_52 = { class: "col-xl-3 col-md-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Tỉnh / Thành phố", -1)
const _hoisted_54 = { class: "col-xl-3 col-md-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Phường / Xã", -1)
const _hoisted_56 = { class: "col-xl-6 col-12" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)", -1)
const _hoisted_58 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "4"),
  /*#__PURE__*/_createTextVNode(" Thông tin hóa đơn (Mã số thuế)")
], -1)
const _hoisted_60 = { class: "row g-5" }
const _hoisted_61 = { class: "col-xl-4 col-md-6" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Mã số thuế công ty", -1)
const _hoisted_63 = { class: "d-flex gap-2" }
const _hoisted_64 = { class: "col-xl-4 col-md-6" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Tên công ty", -1)
const _hoisted_66 = { class: "col-xl-4 col-md-6" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Tên quốc tế", -1)
const _hoisted_68 = { class: "col-xl-4 col-md-6" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Tên viết tắt", -1)
const _hoisted_70 = { class: "col-xl-4 col-md-6" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Địa chỉ", -1)
const _hoisted_72 = { class: "col-xl-4 col-md-6" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Email nhận hóa đơn", -1)
const _hoisted_74 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded p-5 mb-5"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "5"),
  /*#__PURE__*/_createTextVNode(" Thông tin thêm")
], -1)
const _hoisted_76 = { class: "row g-5" }
const _hoisted_77 = { class: "col-xl-4 col-md-6" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Trạng thái", -1)
const _hoisted_79 = { class: "col-xl-4 col-md-6" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Điều kiện tốt nghiệp THPT", -1)
const _hoisted_81 = {
  key: 0,
  class: "text-end umt-sticky-footer"
}
const _hoisted_82 = ["disabled"]
const _hoisted_83 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_84 = {
  key: 0,
  class: "text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.isAddProfile?'':'mb-6 mb-xl-9'])
  }, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      "show-message": false,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        (_ctx.dataCustomer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.sectionTitle)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.sectionTitle), 1))
                : _createCommentVNode("", true),
              (_ctx.missingImportant.length)
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 1,
                    type: "warning",
                    closable: false,
                    class: "umt-warn-banner mb-5"
                  }, {
                    title: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4,
                      _createTextVNode(" " + _toDisplayString(_ctx.missingImportant.join(', ')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_el_form_item, { prop: "fullName" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          disabled: !_ctx.isEdit,
                          class: "text-transform-uppercase",
                          name: "fullname",
                          modelValue: _ctx.formData.fullName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.fullName) = $event)),
                          placeholder: "Họ tên đầy đủ"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_el_form_item, { prop: "idCard" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          disabled: !_ctx.isEdit,
                          name: "idCard",
                          modelValue: _ctx.formData.idCard,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.idCard) = $event)),
                          placeholder: "CMND/CCCD",
                          onChange: _ctx.checkIdCard
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              onClick: _ctx.openScanCccd,
                              title: "Quét CCCD bằng AI để lấy số CMND/CCCD"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_12, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen004.svg" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    (_ctx.messErr!='')
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "text-danger fs-8",
                          innerHTML: _ctx.messErr
                        }, null, 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_form_item, { prop: "dateOfIssue" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "w-100",
                          modelValue: _ctx.formData.dateOfIssue,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dateOfIssue) = $event)),
                          name: "dateOfIssue",
                          placeholder: "Ngày/tháng/năm",
                          format: "DD/MM/YYYY",
                          "value-format": "YYYY-MM-DD",
                          disabled: !_ctx.isEdit
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_form_item, { prop: "issuePlace" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Nơi cấp",
                          modelValue: _ctx.formData.issuePlace,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.issuePlace) = $event)),
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Bộ công an",
                              value: "Bộ công an"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Bộ công an")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội",
                              value: "Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_el_form_item, { prop: "gender" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Giới tính",
                          modelValue: _ctx.formData.gender,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.gender) = $event)),
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Nam",
                              value: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Nam")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "Nữ",
                              value: false
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Nữ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_el_form_item, { prop: "birthPlace" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Nơi sinh",
                          modelValue: _ctx.formData.birthPlace,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.birthPlace) = $event)),
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.name
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_el_form_item, { prop: "dateOfBirth" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "w-100",
                          modelValue: _ctx.formData.dateOfBirth,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.dateOfBirth) = $event)),
                          name: "birthday",
                          placeholder: "Ngày/tháng/năm",
                          format: "DD/MM/YYYY",
                          "default-value": new Date('01/01/2005'),
                          disabled: !_ctx.isEdit
                        }, null, 8, ["modelValue", "default-value", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_el_form_item, { prop: "phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "tel",
                          disabled: !_ctx.isEdit,
                          name: "phone",
                          modelValue: _ctx.formData.phone,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.phone) = $event)),
                          placeholder: "Số điện thoại"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_el_form_item, { prop: "email" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          disabled: !_ctx.isEdit,
                          name: "email",
                          modelValue: _ctx.formData.email,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.email) = $event)),
                          placeholder: "Email"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_el_form_item, { prop: "ethnic" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Dân tộc",
                          modelValue: _ctx.formData.ethnic,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.ethnic) = $event)),
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrEthnic, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_el_form_item, { prop: "religion" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Tôn giáo",
                          modelValue: _ctx.formData.religion,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.religion) = $event)),
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrReligion, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_el_form_item, { prop: "nationality" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Quốc tịch",
                          modelValue: _ctx.formData.nationality,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.nationality) = $event)),
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrNational, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_el_input, {
                      type: "text",
                      disabled: !_ctx.isEdit,
                      name: "taxNumber",
                      modelValue: _ctx.formData.taxNumber,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.taxNumber) = $event)),
                      placeholder: "Mã số thuế cá nhân"
                    }, null, 8, ["disabled", "modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode(_component_el_form_item, { prop: "prProvinceId" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          key: _ctx.formData.prProvinceId,
                          class: "w-100",
                          placeholder: "Tỉnh/Thành phố",
                          modelValue: _ctx.formData.prProvinceId,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.prProvinceId) = $event)),
                          onChange: _ctx.residenceProvinceChange,
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange", "disabled"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_el_form_item, { prop: "prWardId" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Phường/Xã",
                          key: _ctx.formData.prWardId,
                          modelValue: _ctx.formData.prWardId,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.prWardId) = $event)),
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataResidenceWard, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_el_form_item, { prop: "prAddress" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          disabled: !_ctx.isEdit,
                          name: "prAddress",
                          modelValue: _ctx.formData.prAddress,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.prAddress) = $event)),
                          placeholder: "Hộ khẩu thường trú (sau sáp nhập)"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createTextVNode(" Địa chỉ liên lạc "),
                  _createElementVNode("span", _hoisted_48, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: !_ctx.isEdit,
                      id: "checkAddress",
                      onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.autofillAddress && _ctx.autofillAddress(...args)))
                    }, null, 40, _hoisted_49),
                    _hoisted_50
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    (_openBlock(), _createBlock(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "Tỉnh/Thành phố",
                      key: _ctx.formData.contactProvinceId,
                      modelValue: _ctx.formData.contactProvinceId,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.contactProvinceId) = $event)),
                      onChange: _ctx.provinceChange,
                      filterable: true,
                      disabled: !_ctx.isEdit
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"]))
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_el_form_item, { prop: "contactWardId" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "w-100",
                          placeholder: "Phường/Xã",
                          key: _ctx.formData.contactWardId,
                          modelValue: _ctx.formData.contactWardId,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.contactWardId) = $event)),
                          filterable: true,
                          disabled: !_ctx.isEdit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataWard, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createVNode(_component_el_form_item, { prop: "contactAddress" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          disabled: !_ctx.isEdit,
                          name: "contactAddress",
                          modelValue: _ctx.formData.contactAddress,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.contactAddress) = $event)),
                          placeholder: "Địa chỉ liên lạc (sau sáp nhập)"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_el_input, {
                        type: "text",
                        disabled: !_ctx.isEdit,
                        name: "taxCode",
                        modelValue: _ctx.formData.objectTax.id,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.objectTax.id) = $event)),
                        placeholder: "Mã số thuế công ty"
                      }, null, 8, ["disabled", "modelValue"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        disabled: !_ctx.isEdit,
                        loading: _ctx.isLookingUp,
                        onClick: _ctx.findTaxCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Truy cứu")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading", "onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode(_component_el_input, {
                      type: "text",
                      disabled: !_ctx.isEdit,
                      name: "taxName",
                      modelValue: _ctx.formData.objectTax.name,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.objectTax.name) = $event)),
                      placeholder: "Tên công ty"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode(_component_el_input, {
                      type: "text",
                      disabled: !_ctx.isEdit,
                      name: "internationalName",
                      modelValue: _ctx.formData.objectTax.internationalName,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.objectTax.internationalName) = $event)),
                      placeholder: "Tên quốc tế"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_el_input, {
                      type: "text",
                      disabled: !_ctx.isEdit,
                      name: "shortName",
                      modelValue: _ctx.formData.objectTax.shortName,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.objectTax.shortName) = $event)),
                      placeholder: "Tên viết tắt"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createVNode(_component_el_input, {
                      type: "text",
                      disabled: !_ctx.isEdit,
                      name: "taxAddress",
                      modelValue: _ctx.formData.objectTax.address,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.objectTax.address) = $event)),
                      placeholder: "Địa chỉ"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createVNode(_component_el_input, {
                      type: "text",
                      disabled: !_ctx.isEdit,
                      name: "taxEmail",
                      modelValue: _ctx.formData.objectTax.email,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.objectTax.email) = $event)),
                      placeholder: "Email nhận hóa đơn"
                    }, null, 8, ["disabled", "modelValue"])
                  ])
                ])
              ]),
              (_ctx.isAddProfile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode(_component_el_form_item, { prop: "status" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "w-100",
                              placeholder: "Chọn trạng thái",
                              modelValue: _ctx.formData.status,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.status) = $event)),
                              ref: "selectStatus",
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Mới",
                                  value: "new"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Mới")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Đã xác thực",
                                  value: "verified"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Đã xác thực")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Chưa hoàn tất",
                                  value: "processing"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Chưa hoàn tất")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Đang xem xét",
                                  value: "reviewing"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Đang xem xét")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Không hợp lệ",
                                  value: "rejected"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Không hợp lệ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Từ chối",
                                  value: "denied"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Từ chối")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createVNode(_component_el_form_item, { prop: "highschoolGraduation" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "w-100",
                              placeholder: "Chọn điều kiện tốt nghiệp THPT",
                              modelValue: _ctx.formData.highschoolGraduation,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.highschoolGraduation) = $event)),
                              ref: "statusGraduated",
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Chưa tốt nghiệp THPT",
                                  value: "not_graduated"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Chưa tốt nghiệp THPT")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Giấy chứng nhận TNTT",
                                  value: "temp_graduated"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Giấy chứng nhận TNTT")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Đã tốt nghiệp THPT",
                                  value: "graduated"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Đã tốt nghiệp THPT")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isAddProfile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (_ctx.isEdit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _createElementVNode("span", {
                            class: "btn btn-light me-3",
                            onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.loadDefaultData && _ctx.loadDefaultData(...args)))
                          }, "Hủy bỏ"),
                          _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary",
                            disabled: _ctx.saving
                          }, [
                            (_ctx.saving)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_83))
                              : _createCommentVNode("", true),
                            _createTextVNode("Lưu thay đổi")
                          ], 8, _hoisted_82)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isAddProfile && !_ctx.hideActions)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    (_ctx.isEdit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createVNode(_component_router_link, {
                            to: "/danhsachungvien",
                            class: "btn btn-light me-3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hủy bỏ")
                            ]),
                            _: 1
                          }),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('requestSave')))
                          }, "Lưu thông tin")
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ], 2))
}